import { createAsyncThunk } from '@reduxjs/toolkit';
import { DashboardReport } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindDashboardReport } from './interface';

export const findDashboardReport = createAsyncThunk(
  'dashboardReport/findDashboardReport',
  async (values: FindDashboardReport, { rejectWithValue }) => {
    try {
      const response = await DashboardReport.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  });